function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Input } from './input';
import { Button } from './button';
var baseStyle = () => _objectSpread(_objectSpread({}, Input.baseStyle()), {}, {
  container: {
    _focusWithin: {
      boxShadow: "none",
      '> .tqc-input': {
        borderColor: "grey.500",
        _focus: {
          boxShadow: "0 0 3px 2px #2182EB",
          borderColor: "blue.500"
        }
      }
    },
    '> .tqc-input': {
      borderRadius: 'sm',
      boxShadow: "none",
      _focus: {
        borderRadius: '4px',
        borderWidth: '1px'
      }
    }
  },
  addon: _objectSpread(_objectSpread({}, Button.variants.primary.button), {}, {
    border: 0,
    fontSize: 'lg',
    borderRadius: '0px 4px 4px 0px',
    px: 2,
    minWidth: 11,
    height: '100%',
    position: 'absolute',
    right: '0',
    zIndex: 1,
    _focus: {
      bg: 'blue.900',
      borderColor: 'blue.300',
      boxShadow: "0px 0px 4px 2px #4CAAF0",
      color: 'white',
      outline: 'none'
    }
  })
});
export var SearchInput = {
  baseStyle
};